import React from 'react'
import { CallToAction } from 'components/CallToAction'
import { prepareData } from 'utils/googleData'

export function DocsGettingStarted(props) {
    const {
        articleType,
        enable,
        title,
        subtitle,
        text,
        cta,
        direction,
        style,
        lottie,
        gatsbyImage,
        items,
        gatsbyImageSrc,
        description,
        children,
    } = prepareData({
        props,
    })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <div className="relative clear-both flex items-center border-y border-dashed border-gray-accent-light py-4 dark:border-gray-accent-dark">
            <div className="flex w-full flex-col items-center gap-4 sm:flex-row">
                <div className="w-full flex-1">
                    <div className="mb-2 flex flex-row items-center space-x-1 opacity-60">
                        <span className="text-xs font-semibold uppercase">{articleType}</span>
                    </div>
                    <h3 className="mb-2 mt-0">{title}</h3>
                    <p className="mb-0 max-w-md">{description}</p>
                </div>

                <aside className="w-full sm:w-auto sm:flex-shrink">
                    <CallToAction to={cta?.url}>{cta?.label} &rarr;</CallToAction>
                </aside>
            </div>

            {children && <div className="max-w-1/2 absolute right-0 top-0 hidden h-full md:block">{children}</div>}
        </div>
    )
}
export default DocsGettingStarted
